function bytesToMB(a){
    return a/Math.pow(1024,2)
}

export default bytesToMB